var map = {
	"./Img-01.jpg": 466,
	"./Img-02.jpg": 467,
	"./Img-03.jpg": 468,
	"./Img-05.jpg": 469,
	"./Img-07.jpg": 470,
	"./K.png": 471,
	"./articles-bg.jpg": 472,
	"./articles/8-considerations-for-api-design.jpg": 226,
	"./articles/a-teams-self-determination-and-a-decentralised-team.jpg": 227,
	"./articles/advisor-introduction-anssi-pakkanen.jpg": 228,
	"./articles/advisor-introduction-ilkka-suhonen.jpg": 229,
	"./articles/an-individuals-self-determination-and-a-decentralised-team.jpg": 230,
	"./articles/blog_list1.jpg": 231,
	"./articles/blog_list2.jpg": 232,
	"./articles/blog_list3.jpg": 233,
	"./articles/blog_list4.jpg": 234,
	"./articles/graph-database-intro-img-1.png": 165,
	"./articles/graph-database-intro-img-2.png": 166,
	"./articles/graph-database-intro.jpg": 235,
	"./articles/lessons-from-a-fresh-entrepreneur.jpg": 236,
	"./articles/member-introduction-maciej-polak.jpg": 237,
	"./articles/member-introduction-mateusz-wojciechowski.jpg": 238,
	"./articles/member-introduction-piotr-chojnacki.jpg": 239,
	"./articles/mikko-kojon-product-director-sympa-oy-vinkit-hajautetun-ohjelmistokehitystiimin-kayttoon.jpg": 240,
	"./articles/polar-software-meeting017.jpg": 241,
	"./authors/anssi-pakkanen.jpg": 242,
	"./authors/henri-jaaskelainen.jpg": 243,
	"./authors/ilkka-suhonen.jpg": 244,
	"./authors/maciej-polak.jpg": 245,
	"./authors/mateusz-wojciechowski.jpg": 246,
	"./authors/mikko-kojo.jpg": 247,
	"./authors/piotr-chojnacki.jpg": 248,
	"./b.png": 473,
	"./blob-shape.svg": 474,
	"./blog-grid/author_img.png": 475,
	"./blog-grid/blog_list1.jpg": 476,
	"./blog-grid/blog_list2.jpg": 477,
	"./blog-grid/blog_list3.jpg": 249,
	"./blog-grid/blog_list4.jpg": 478,
	"./blog-grid/blog_single.png": 250,
	"./blog-grid/comment1.png": 479,
	"./blog-grid/comment2.png": 480,
	"./blog-grid/post_1.jpg": 481,
	"./blog-grid/post_2.jpg": 482,
	"./blog-grid/post_3.jpg": 483,
	"./blog-grid/post_4.jpg": 484,
	"./blog-grid/post_img_1.png": 485,
	"./blog-grid/post_img_2.png": 486,
	"./blog-grid/post_img_3.png": 487,
	"./br_logo.png": 488,
	"./breadcrumb/banner_bg.png": 489,
	"./breadcrumb/service.png": 490,
	"./breadcrumb/service_details.png": 491,
	"./breadcrumb/service_details_one.png": 492,
	"./cart1.jpg": 493,
	"./cart2.jpg": 494,
	"./contact-bg.jpg": 495,
	"./erp-home/action_img.png": 496,
	"./erp-home/background.png": 497,
	"./erp-home/banner_shap.png": 498,
	"./erp-home/cloud-computing.png": 499,
	"./erp-home/cloud_01.png": 500,
	"./erp-home/cloud_02.png": 501,
	"./erp-home/cloud_03.png": 502,
	"./erp-home/cloud_04.png": 503,
	"./erp-home/cloud_05.png": 504,
	"./erp-home/cloud_06.png": 505,
	"./erp-home/crm_img1.jpg": 506,
	"./erp-home/crm_img2.jpg": 507,
	"./erp-home/crm_img3.jpg": 508,
	"./erp-home/erp_dashboard.jpg": 509,
	"./erp-home/erp_icon1.png": 510,
	"./erp-home/erp_icon2.png": 511,
	"./erp-home/erp_icon3.png": 512,
	"./erp-home/erp_icon4.png": 513,
	"./erp-home/erp_icon5.png": 514,
	"./erp-home/erp_icon6.png": 515,
	"./erp-home/growth.png": 516,
	"./erp-home/img/01.png": 517,
	"./erp-home/img/02.png": 518,
	"./erp-home/img/03.png": 519,
	"./erp-home/img/04.png": 520,
	"./erp-home/img/05.png": 521,
	"./erp-home/img/06.png": 522,
	"./erp-home/img/07.png": 523,
	"./erp-home/img/08.png": 524,
	"./erp-home/img/09.png": 525,
	"./erp-home/img/10.png": 526,
	"./erp-home/img/11.png": 527,
	"./erp-home/img/12.png": 528,
	"./erp-home/img/13.png": 529,
	"./erp-home/img/14.png": 530,
	"./erp-home/img/15.png": 531,
	"./erp-home/img/16.png": 532,
	"./erp-home/img/17.png": 533,
	"./erp-home/img/18.png": 534,
	"./erp-home/img/19.png": 535,
	"./erp-home/img/20.png": 536,
	"./erp-home/quote.png": 537,
	"./erp-home/rocket.png": 538,
	"./erp-home/settings1.png": 539,
	"./erp-home/shape.png": 540,
	"./erp-home/testimonial_img.jpg": 541,
	"./erp-home/testimonial_img2.jpg": 542,
	"./error_bg.png": 543,
	"./favicon.png": 544,
	"./home-software/down_bg.png": 545,
	"./home2/action_bg.png": 546,
	"./home2/file.png": 547,
	"./home2/inbox.png": 548,
	"./home2/report.png": 549,
	"./home2/undraw.png": 550,
	"./home3/action_image.png": 551,
	"./home3/customer-logo-1.png": 552,
	"./home3/customer-logo-2.png": 553,
	"./home3/customer-logo-3.png": 554,
	"./home3/dimond.png": 555,
	"./home3/logo_01.png": 556,
	"./home3/logo_02.png": 557,
	"./home3/logo_03.png": 558,
	"./home3/logo_04.png": 559,
	"./home3/logo_05.png": 560,
	"./home3/p_feature1.png": 561,
	"./home3/prototype_banner_img.png": 562,
	"./home3/prototype_banner_img2.png": 563,
	"./home3/psd.png": 564,
	"./home3/saas.png": 565,
	"./home3/tab.png": 566,
	"./home4/action_shap.png": 251,
	"./home4/author_img.png": 252,
	"./home4/banner_bg.png": 124,
	"./home4/banner_img.png": 253,
	"./home4/divider.png": 254,
	"./home4/dot.png": 255,
	"./home4/icon01.png": 256,
	"./home4/icon02.png": 257,
	"./home4/icon3.png": 258,
	"./home4/icon_04.png": 259,
	"./home4/icon_05.png": 260,
	"./home4/icon_shape1.png": 261,
	"./home4/icon_shape2.png": 262,
	"./home4/icon_shape3.png": 263,
	"./home4/icon_shape4.png": 264,
	"./home4/process_1.png": 167,
	"./home4/process_2.png": 168,
	"./home4/process_3.png": 265,
	"./home4/process_4.png": 169,
	"./home4/process_5.png": 266,
	"./home4/shape.png": 267,
	"./home4/team1.jpg": 170,
	"./home4/team2.jpg": 171,
	"./home4/team5.jpg": 172,
	"./home4/team6.jpg": 173,
	"./home4/team8.jpg": 174,
	"./home4/team9.jpg": 175,
	"./home4/work1.png": 268,
	"./home4/work2.png": 269,
	"./home4/work3.png": 270,
	"./home5/01.jpg": 567,
	"./home5/02.jpg": 568,
	"./home5/03.jpg": 569,
	"./home5/banner_img.png": 570,
	"./home5/design1.png": 571,
	"./home5/design2.png": 572,
	"./home5/featured_bg_shape.png": 573,
	"./home5/featured_img1.png": 574,
	"./home5/icon1.png": 575,
	"./home5/icon2.png": 576,
	"./home5/icon3.png": 577,
	"./home5/icon_shape.png": 578,
	"./home5/php.jpg": 579,
	"./home5/shap_tecture.png": 580,
	"./home7/01.png": 581,
	"./home7/02.png": 582,
	"./home7/03.png": 583,
	"./home7/app.png": 584,
	"./home7/banner-old.png": 585,
	"./home7/banner.jpg": 586,
	"./home7/google_icon.png": 587,
	"./home7/iPhoneX2.png": 588,
	"./home7/iPhonex.png": 589,
	"./home7/iPhonex.xcf": 590,
	"./home7/jonatan-pie-3l3RwQdHRHg-unsplash.jpg": 591,
	"./home7/screenshot1.png": 592,
	"./home7/screenshot2.png": 593,
	"./home7/screenshot3.png": 594,
	"./home7/screenshot4.png": 595,
	"./home7/screenshot5.png": 596,
	"./home7/team_01.jpg": 597,
	"./home7/team_02.jpg": 598,
	"./home7/team_03.jpg": 599,
	"./home7/team_04.jpg": 600,
	"./home7/testimonial_1.png": 601,
	"./home7/text_one.png": 602,
	"./home7/text_three.png": 603,
	"./home7/text_two.png": 604,
	"./home8/banner_img.png": 605,
	"./home8/dot.png": 606,
	"./home8/fact.png": 607,
	"./home8/service_item_03.png": 608,
	"./home9/featured_img.png": 609,
	"./home9/featured_img_two.png": 610,
	"./home9/flag.png": 611,
	"./home9/footer.png": 612,
	"./home9/icon1.png": 613,
	"./home9/icon2.png": 614,
	"./home9/icon3.png": 615,
	"./home9/icon4.png": 616,
	"./home9/icon5.png": 617,
	"./home9/icon6.png": 618,
	"./home9/icon7.png": 619,
	"./home9/icon8.png": 620,
	"./home9/icon_shape.png": 621,
	"./home9/icon_shape_two.png": 622,
	"./home9/logo1.png": 623,
	"./home9/logo2.png": 624,
	"./home9/logo3.png": 625,
	"./home9/logo4.png": 626,
	"./home9/logo5.png": 627,
	"./home9/logo6.png": 628,
	"./home9/logo7.png": 629,
	"./home9/logo8.png": 630,
	"./home9/mac.png": 631,
	"./home9/map.png": 632,
	"./home9/shape-footer.png": 633,
	"./home9/shape.png": 634,
	"./home9/shape_two.png": 635,
	"./home9/testimonial_img.png": 636,
	"./home9/testimonial_img2.png": 637,
	"./home9/triangle_bottom.png": 638,
	"./home9/triangle_top.png": 639,
	"./hosting/map.png": 640,
	"./hosting/region_map.png": 641,
	"./how-we-work.jpg": 271,
	"./illustrations/nearshore-consulting.jpg": 642,
	"./illustrations/nearshore-consulting.png": 272,
	"./illustrations/software-development.jpg": 643,
	"./illustrations/software-development.png": 273,
	"./illustrations/software-maintenance.jpg": 644,
	"./illustrations/software-maintenance.png": 274,
	"./login_img.png": 645,
	"./login_img2.png": 646,
	"./logo-3-2x.png": 647,
	"./logo-polar-night-2.png": 275,
	"./logo-polar-night-3.png": 176,
	"./logo-polar-night.png": 648,
	"./logo-sticky-2x.png": 649,
	"./logo-sticky.png": 650,
	"./logo-sticky2.png": 651,
	"./logo-sticky3.png": 652,
	"./logo-sticky4.png": 653,
	"./logo.png": 654,
	"./logo2.png": 655,
	"./logo2x-2.png": 656,
	"./logo2x.png": 657,
	"./logo3.png": 658,
	"./logo4.png": 659,
	"./logo7.png": 660,
	"./logo8.png": 661,
	"./mega-menu-img/Prototyping_Tool.jpg": 662,
	"./mega-menu-img/coming_img.jpg": 663,
	"./mega-menu-img/home10.jpg": 664,
	"./mega-menu-img/home11.jpg": 665,
	"./mega-menu-img/home14.jpg": 666,
	"./mega-menu-img/home15.jpg": 667,
	"./mega-menu-img/home16.jpg": 668,
	"./mega-menu-img/home17.jpg": 669,
	"./mega-menu-img/home3.jpg": 670,
	"./mega-menu-img/home4.jpg": 671,
	"./mega-menu-img/icon/app-d.png": 672,
	"./mega-menu-img/icon/blup.png": 673,
	"./new-home/back_bg.png": 674,
	"./new/01.png": 675,
	"./new/0111.png": 676,
	"./new/02.png": 677,
	"./new/0222.png": 678,
	"./new/03.png": 679,
	"./new/04.png": 680,
	"./new/05.png": 681,
	"./new/06.png": 682,
	"./new/app_screen.png": 683,
	"./new/case/case_01.jpg": 684,
	"./new/case/case_02.jpg": 685,
	"./new/case/case_03.jpg": 686,
	"./new/case/case_04.jpg": 687,
	"./new/case/case_05.jpg": 688,
	"./new/case/case_06.jpg": 689,
	"./new/case/case_07.jpg": 690,
	"./new/case/case_08.jpg": 691,
	"./new/case/case_09.jpg": 692,
	"./new/case/case_10.jpg": 693,
	"./new/case/case_11.jpg": 694,
	"./new/case/case_12.jpg": 695,
	"./new/case/case_details_01.jpg": 696,
	"./new/case/case_details_02.jpg": 697,
	"./new/case/case_details_03.jpg": 698,
	"./new/case/parallax.png": 699,
	"./new/coming_soon_bg.png": 700,
	"./new/company.jpg": 701,
	"./new/cup.png": 702,
	"./new/digital_img.png": 703,
	"./new/error.png": 704,
	"./new/features_01.png": 705,
	"./new/feedback_shap.png": 706,
	"./new/home-split/contact.png": 707,
	"./new/iPhoneX.png": 708,
	"./new/icon.png": 709,
	"./new/icon/icon1.png": 710,
	"./new/icon/icon2.png": 711,
	"./new/icon2.png": 712,
	"./new/icon3.png": 713,
	"./new/intregration_1.png": 714,
	"./new/intregration_2.png": 715,
	"./new/intregration_3.png": 716,
	"./new/intregration_4.png": 717,
	"./new/laptop.png": 718,
	"./new/laptop_two.png": 719,
	"./new/leaf.png": 720,
	"./new/line_01.png": 276,
	"./new/line_02.png": 277,
	"./new/line_03.png": 278,
	"./new/logo_01.png": 721,
	"./new/logo_02.png": 722,
	"./new/logo_03.png": 723,
	"./new/logo_04.png": 724,
	"./new/logo_05.png": 725,
	"./new/member_01.jpg": 726,
	"./new/new_shape.png": 727,
	"./new/phone.png": 728,
	"./new/price_bg.png": 729,
	"./new/shape_bg.png": 730,
	"./new/solution_01.jpg": 731,
	"./new/solution_02.jpg": 732,
	"./new/startup_banner_bg.png": 733,
	"./new/startup_banner_img.png": 734,
	"./new/startup_shap.png": 735,
	"./new/tab_shape_bg.png": 736,
	"./new/testimonial_bg.png": 737,
	"./new/testimonial_bg_shap.png": 738,
	"./new/testimonial_bg_two.png": 739,
	"./new/video_bg.jpg": 740,
	"./new/video_img_01.png": 741,
	"./new/video_img_02.jpg": 742,
	"./new/web_image.jpg": 743,
	"./new_logo.png": 744,
	"./our-office.jpg": 279,
	"./polar-software-meeting027.jpg": 745,
	"./portfolio-bg.jpg": 746,
	"./portfolio-details-small/acis-2.png": 280,
	"./portfolio-details-small/acis.jpg": 281,
	"./portfolio-details-small/conversational-intelligence-platform.png": 282,
	"./portfolio-details-small/efecte-itsm.png": 283,
	"./portfolio-details-small/fleetguru.jpg": 284,
	"./portfolio-details-small/insights-analytics-suite.jpg": 285,
	"./portfolio-details-small/kiks.jpg": 286,
	"./portfolio-details-small/leadsense.jpg": 287,
	"./portfolio-details-small/legal-jobs-2.png": 288,
	"./portfolio-details-small/legal-jobs.jpg": 289,
	"./portfolio-details-small/lvs.jpg": 290,
	"./portfolio-details-small/medixine.png": 291,
	"./portfolio-details-small/oulan.jpg": 292,
	"./portfolio-details-small/pr_details1.jpg": 293,
	"./portfolio-details-small/pr_details2.jpg": 294,
	"./portfolio-details-small/pr_details3.jpg": 295,
	"./portfolio-details-small/pr_details4.jpg": 296,
	"./portfolio-details-small/puhujatori.jpg": 297,
	"./portfolio-details-small/renta.jpg": 298,
	"./portfolio-details-small/robu.jpg": 299,
	"./portfolio-details-small/rokko.jpg": 300,
	"./portfolio-details-small/speys.jpg": 301,
	"./portfolio-details-small/valuematcher.jpg": 302,
	"./portfolio-details/acis-2.png": 303,
	"./portfolio-details/acis.jpg": 304,
	"./portfolio-details/conversational-intelligence-platform.png": 305,
	"./portfolio-details/efecte-itsm.png": 306,
	"./portfolio-details/fleetguru.jpg": 307,
	"./portfolio-details/insights-analytics-suite.jpg": 308,
	"./portfolio-details/kiks.jpg": 309,
	"./portfolio-details/leadsense.jpg": 310,
	"./portfolio-details/legal-jobs-2.png": 311,
	"./portfolio-details/legal-jobs.jpg": 312,
	"./portfolio-details/lvs.jpg": 313,
	"./portfolio-details/medixine.png": 314,
	"./portfolio-details/oulan.jpg": 315,
	"./portfolio-details/pr_details1.jpg": 316,
	"./portfolio-details/pr_details2.jpg": 317,
	"./portfolio-details/pr_details3.jpg": 318,
	"./portfolio-details/pr_details4.jpg": 319,
	"./portfolio-details/puhujatori.jpg": 320,
	"./portfolio-details/renta.jpg": 321,
	"./portfolio-details/robu.jpg": 322,
	"./portfolio-details/rokko.jpg": 323,
	"./portfolio-details/speys.jpg": 324,
	"./portfolio-details/valuematcher.jpg": 325,
	"./portfolio/2-columns/acis-2.png": 747,
	"./portfolio/2-columns/acis.jpg": 748,
	"./portfolio/2-columns/grid1.jpg": 749,
	"./portfolio/2-columns/grid2.jpg": 750,
	"./portfolio/2-columns/grid3.jpg": 751,
	"./portfolio/2-columns/grid4.jpg": 752,
	"./portfolio/2-columns/grid5.jpg": 753,
	"./portfolio/2-columns/grid6.jpg": 754,
	"./portfolio/2-columns/grid7.jpg": 755,
	"./portfolio/2-columns/grid8.jpg": 756,
	"./portfolio/2-columns/laptop_two.png": 757,
	"./portfolio/2-columns/legal-jobs-2.png": 758,
	"./portfolio/2-columns/legal-jobs.jpg": 759,
	"./portfolio/3-columns/3_col_1.jpg": 760,
	"./portfolio/3-columns/3_col_10.jpg": 761,
	"./portfolio/3-columns/3_col_11.jpg": 762,
	"./portfolio/3-columns/3_col_12.jpg": 763,
	"./portfolio/3-columns/3_col_2.jpg": 764,
	"./portfolio/3-columns/3_col_3.jpg": 765,
	"./portfolio/3-columns/3_col_4.jpg": 766,
	"./portfolio/3-columns/3_col_5.jpg": 767,
	"./portfolio/3-columns/3_col_6.jpg": 768,
	"./portfolio/3-columns/3_col_7.jpg": 769,
	"./portfolio/3-columns/3_col_8.jpg": 770,
	"./portfolio/3-columns/3_col_9.jpg": 771,
	"./portfolio/full-width/full_1.jpg": 772,
	"./portfolio/full-width/full_10.jpg": 773,
	"./portfolio/full-width/full_11.jpg": 774,
	"./portfolio/full-width/full_12.jpg": 775,
	"./portfolio/full-width/full_2.jpg": 776,
	"./portfolio/full-width/full_3.jpg": 777,
	"./portfolio/full-width/full_4.jpg": 778,
	"./portfolio/full-width/full_5.jpg": 779,
	"./portfolio/full-width/full_6.jpg": 780,
	"./portfolio/full-width/full_7.jpg": 781,
	"./portfolio/full-width/full_8.jpg": 782,
	"./portfolio/full-width/full_9.jpg": 783,
	"./pos/leaf-left.png": 784,
	"./pos/leaf-right.png": 785,
	"./pos/shape.png": 786,
	"./pos/shape_bg.png": 787,
	"./pos/wave_two.png": 788,
	"./price/one.png": 789,
	"./price/three.png": 790,
	"./price/two.png": 791,
	"./process/ASAN-logo-icon.png": 792,
	"./process/Avast_Antivirus.png": 793,
	"./process/UTorrent_(logo).png": 794,
	"./process/btFMmsoh.png": 795,
	"./process/logo-slack.png": 796,
	"./process/png-logo-design.png": 797,
	"./qoute.png": 798,
	"./saas/map.png": 799,
	"./seo/bike.png": 800,
	"./seo/car.png": 801,
	"./seo/cloud.png": 802,
	"./seo/cloud_bg.png": 803,
	"./seo/features_img.png": 804,
	"./seo/features_img_two.png": 805,
	"./seo/footer_bg.png": 806,
	"./seo/icon1.png": 807,
	"./seo/icon2.png": 808,
	"./seo/icon3.png": 809,
	"./seo/icon4.png": 810,
	"./seo/icon5.png": 811,
	"./seo/image.png": 812,
	"./seo/logo_01.png": 813,
	"./seo/logo_02.png": 814,
	"./seo/logo_03.png": 815,
	"./seo/logo_04.png": 816,
	"./seo/logo_05.png": 817,
	"./seo/logo_06.png": 818,
	"./seo/logo_07.png": 819,
	"./seo/logo_08.png": 820,
	"./seo/logo_09.png": 821,
	"./seo/shap.png": 822,
	"./seo/studies_img_one.jpg": 823,
	"./seo/studies_img_three.jpg": 824,
	"./seo/studies_img_two.jpg": 825,
	"./seo/triangle_one.png": 826,
	"./seo/triangle_three.png": 827,
	"./seo/triangle_two.png": 828,
	"./services-bg.jpg": 829,
	"./smartphone.png": 830,
	"./svg.svg": 831,
	"./teams/Z61_8694.jpg": 326,
	"./teams/adam-lapinski.jpg": 327,
	"./teams/adrian-dworanowski.jpg": 328,
	"./teams/aku-kajan-portrait-transparent.png": 125,
	"./teams/aku-kajan.jpg": 329,
	"./teams/henri-jaaskelainen.jpg": 330,
	"./teams/ilkka-suhonen.jpg": 331,
	"./teams/kamil-karpus.jpg": 332,
	"./teams/klaudia-modrzejewska.jpg": 333,
	"./teams/maciej-kowalski.jpg": 334,
	"./teams/maciej-polak.jpg": 335,
	"./teams/margarita-nikolenko.jpg": 336,
	"./teams/marlena-kiryk.jpg": 337,
	"./teams/mateusz-wojciechowski.jpg": 338,
	"./teams/mateusz-wozniak.jpg": 339,
	"./teams/michal-piotrowski.jpg": 340,
	"./teams/patryk-bartczyk.jpg": 341,
	"./teams/pawel-kieryk.jpg": 342,
	"./teams/pawel-kruzynski.jpg": 343,
	"./teams/pawel-zych.jpg": 344,
	"./teams/piotr-chojnacki-1.jpg": 345,
	"./teams/piotr-chojnacki.jpg": 346,
	"./teams/przemyslaw-szmigiel.jpg": 347,
	"./teams/rokko-karhuvaara.jpg": 348,
	"./teams/szczepan-gawlik.jpg": 349,
	"./teams/szymon-grzelaczyk.jpg": 350,
	"./teams/wojciech-brzozka.jpg": 351,
	"./teams/zbigniew-sznajder.jpg": 352,
	"./test.png": 832,
	"./testimonials/testimonial-efecte.png": 353,
	"./testimonials/testimonial-fleetguru.png": 354,
	"./testimonials/testimonial-kiks.png": 355,
	"./testimonials/testimonial-legal-jobs.png": 356,
	"./testimonials/testimonial-lvs-brokers.png": 357,
	"./testimonials/testimonial-medixine.png": 358,
	"./testimonials/testimonial-oulan.png": 359,
	"./testimonials/testimonial-puhujatori.png": 360,
	"./testimonials/testimonial-renta.png": 361,
	"./testimonials/testimonial-robu.png": 362,
	"./testimonials/testimonial-speys.png": 363,
	"./testimonials/testimonial-src-factory.png": 364,
	"./wave-long.svg": 833,
	"./wave.svg": 834,
	"./wave2.svg": 835,
	"./wave3.svg": 836,
	"./wave4.svg": 837
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 465;